import {
  PersonaTypesOrg,
  PreferencesKeys,
  ReportFeaturesComps,
  ReportFeaturesRentalComps,
  ReportFeaturesSubject,
  UiPreferences,
} from '@hcs/types';

export const UI_PREFERENCE_TEMPLATE_MORTGAGE_LENDERS: UiPreferences = {
  [PreferencesKeys.Persona]: PersonaTypesOrg.MortgageLender,
  [PreferencesKeys.ReportFeaturesSubject]: {
    [ReportFeaturesSubject.Comments]: true,
    [ReportFeaturesSubject.Sharing]: true,
    [ReportFeaturesSubject.Download]: true,
    [ReportFeaturesSubject.KeyFacts]: true,
    [ReportFeaturesSubject.Insights]: true,
    [ReportFeaturesSubject.Personalization]: true,
    [ReportFeaturesSubject.HeatMaps]: true,
  },
  [PreferencesKeys.ReportFeaturesComps]: {
    [ReportFeaturesComps.Enabled]: true,
    [ReportFeaturesComps.AddCompByMlsNumber]: true,
    [ReportFeaturesComps.SavedCompFilters]: true,
    [ReportFeaturesComps.RefreshComps]: true,
    [ReportFeaturesComps.Tags]: true,
    [ReportFeaturesComps.AdjustComps]: true,
    [ReportFeaturesComps.CustomAreaCompSearch]: true,
    [ReportFeaturesComps.AutoSelectHcSuggestedComps]: true,
    [ReportFeaturesComps.KeywordSearch]: true,
  },
  [PreferencesKeys.ReportFeaturesRentalComps]: {
    [ReportFeaturesRentalComps.Enabled]: false,
  },
};
